import { render, staticRenderFns } from "./SpaJingTangGe.vue?vue&type=template&id=70b615fb&scoped=true"
import script from "./SpaJingTangGe.vue?vue&type=script&lang=js"
export * from "./SpaJingTangGe.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/roomdetail.css?vue&type=style&index=0&id=70b615fb&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b615fb",
  null
  
)

export default component.exports